import { render, staticRenderFns } from "./colorbarMarkerForm.vue?vue&type=template&id=00bbb293"
import script from "./colorbarMarkerForm.vue?vue&type=script&lang=js"
export * from "./colorbarMarkerForm.vue?vue&type=script&lang=js"
import style0 from "./colorbarMarkerForm.vue?vue&type=style&index=0&id=00bbb293&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports